import { render, staticRenderFns } from "./Finished.vue?vue&type=template&id=b1f7baca&scoped=true"
import script from "./Finished.vue?vue&type=script&lang=ts"
export * from "./Finished.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f7baca",
  null
  
)

export default component.exports